import { FlaskConicalIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router';

import NotFound from '@/components/pages/NotFound/NotFound';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';
import { PaidFeatureGate } from '@/modules/billing/components/PaidFeatureGate/PaidFeatureGate';
import { PaidFeatureUpsell } from '@/modules/billing/components/PaidFeatureUpsell/PaidFeatureUpsell';
import { PageName } from '@/shared/types/segment';

import { SIMULATIONS_LAST_TAB_KEY, useCreateSimulationRequest } from './navigation';
import { RunDetailsPage } from './RunDetailsPage';
import { SimulationsPage } from './SimulationsPage';

const SimulationsIndex = () => {
  const createRequest = useCreateSimulationRequest();
  const showsOverview =
    !createRequest && localStorage.getItem(SIMULATIONS_LAST_TAB_KEY) === 'overview';

  return showsOverview ? <Navigate to="overview" replace /> : <SimulationsPage tab="simulations" />;
};

export const SimulationsRouter = () => {
  const { t } = useTranslation();

  return (
    <PaidFeatureGate
      pageName={PageName.SIMULATIONS}
      paywall={
        <PaidFeatureUpsell
          icon={<FlaskConicalIcon aria-hidden />}
          title={t('simulations.paywall_title')}
          description={t('simulations.paywall_description')}
        />
      }
    >
      <PermissionsWrapper module="brains">
        <Routes>
          <Route index element={<SimulationsIndex />} />
          <Route path="overview" element={<SimulationsPage tab="overview" />} />
          <Route path="runs/:runId" element={<RunDetailsPage />} />
          <Route path="runs/:runId/:simulationId" element={<RunDetailsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PermissionsWrapper>
    </PaidFeatureGate>
  );
};
